<div class="container">
  <div class="login-section">
    <img class="logo" src="assets/images/sparkly_logo.png" alt="Logo">

    <div class="header">
      <h1 translate>login.login</h1>
      <p>Wilkommen zurück bei Sparkly! 👋</p>
    </div>

    <app-alert *ngIf="wrongCredentials" [title]="'login.failed_title' | translate" [message]="'login.failed_message' | translate" [type]="'error'"></app-alert>
    <app-alert *ngIf="emailNotConfirmed" [title]="'login.email_not_confirmed_title' | translate" [message]="'login.email_not_confirmed_message' | translate" [messageAction]="'login.resend_email' | translate" [type]="'info'" [actionIcon]="confirmationMailSent ? 'fa-check' : ''" (actionClicked)="resendConfirmEmail()"></app-alert>
    
    <form [formGroup]="form!" class="login-form" (ngSubmit)="submit()">
      <app-text-input formControlName="email" [control]="getControl('email')" [inputName]="'email'" [(value)]="email" [label]="'login.email' | translate" type="email" [placeholder]="'login.email_placeholder' | translate"></app-text-input>
      <app-text-input formControlName="password" [control]="getControl('password')" [inputName]="'password'" [(value)]="password" [label]="'login.password' | translate" [placeholder]="'login.password_placeholder' | translate" type="password"></app-text-input>
      <p class="forgot-password"><a href="/forgot-password">{{'login.forgot_password' | translate}}</a></p>
      <app-button [text]="'login.login' | translate" type="submit" [loading]="isLoading"></app-button>
      <p class="register-option">{{'login.sign_up_info' | translate}} <a href="/register">{{'login.sign_up' | translate}}</a></p>
    </form>
  </div>

  <!--<div class="hero-section">
    <img class="image" src="assets/images/login-image.png" alt="Logo">
  </div>-->
</div>